import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly TRAINING: string[] = ['training'];
  private readonly PRE: string[] = ['live.cextrapre.it','live.costaextrapre.it'];
  private readonly TEST: string[] = ['live.cextratest.it','live.costaextratest.it'];

  public isProd(): boolean {
    return !this.isLocal() && !this.isPre() && !this.isTest() && !this.isTraining();
  }

  public isPre(): boolean {
    return this.isLocationOriginContainedIn(this.PRE);
  }

  public isTraining(): boolean {
    return this.isLocationOriginContainedIn(this.TRAINING);
  }

  public isTest(): boolean {
    return this.isLocationOriginContainedIn(this.TEST);
  }

  public isLocal(): boolean {
    return location.origin.indexOf('oto') >= 0;
  }

  private isLocationOriginContainedIn(urls: string[]): boolean {
    return urls.some(url => location.origin.indexOf(url) >= 0);
  }
}
